<script>

import accountService from '@/services/account.service'
import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import Icon from "@/components/Icon/Icon.vue"
import Dialog from 'primevue/dialog'

export default {
  name: 'AccountGroupModal',
  components: {
      accountService,
      VeeForm,
      Field,
      ErrorMessage,
      Icon,
      Dialog,
  },
  data() {
      return {
        uuidGroupe: '',
        nomGroupe: '',
        showModal: false,
        traited: false,
      }
  },
  setup() {
      const schema = yup.object().shape({
        nomGroupe: yup.string()
          .typeError("Le nom du groupe doit être rempli")
          .required("Le nom du groupe est obligatoire")
      });

      return {
          schema,
      }
  },
  props: {
      externUuidModal: {
          type: String
      },
      externGroupeModal: {
          type: String
      },
      externShowEditGroupModal: {
          type: Boolean
      },
  },
  watch: {
      externUuidModal: function(newVal) {
          this.uuidGroupe = newVal
      },
      externGroupeModal: function(newVal) {
          this.nomGroupe = newVal
      },
      externShowEditGroupModal: function(newVal) {
          this.showModal = newVal
      },
  },
  computed: {
    disabledGroup() {
      if(this.uuidGroupe != '') return true

      return false
    },
  },
  methods: {
      beforeClose () {
          this.showModal = false
          this.$emit('close', {
            traited: this.traited,
            name: this.nomGroupe,
          });
          this.traited = false
          this.uuidGroupe = ''
          this.nomGroupe = ''
      },
      close() {
        this.showModal = false
      },
      handleEdit(form) {
          accountService.modify(this.uuidGroupe, this.nomGroupe)
          .then((data) => {
              this.traited = true
              this.nomGroupe = data.name

              this.close()
          })
          .catch(err => {
            this.$moshaToast(err.response.data.error_description, {
              timeout: 3000,
              hideProgressBar: true,
              type: 'warning',
              swipeClose: true,
              position: 'top-center',
            })
          })
      },
  },
}

</script>

<template>
  <Dialog
        v-model:visible="showModal"
        modal
        class="flex justify-center items-center"
        :showHeader="false"
        :dismissableMask="true"
        :baseZIndex="1500"
        contentClass="relative p-0 rounded-lg bg-white dark:bg-gray-900"
        @hide="beforeClose"
    >
      <header class="bg-orange-300 p-2">
        <div class="text-right">
          <div @click="close()" class="cursor-pointer">Fermer</div>
        </div>
      </header>
      <div class="m-0 px-16 py-10 relative bg-white dark:bg-gray-900 border border-orange-300">
          <VeeForm @submit="handleEdit" :validation-schema="schema" class="flex flex-col gap-4">
            <div class="form-group grid grid-cols-form-libre gap-4">
              <span class="flex flex-col justify-center">Nom du groupe</span>
              <Field name="uuidGroupe" v-model="uuidGroupe" class="w-48 form-control form-input" type="hidden" :disabled="disabledGroup" />
              <Field name="nomGroupe" v-model="nomGroupe" class="w-48 form-control form-input" type="text" />
            </div>
            <ErrorMessage name="nomGroupe" v-slot="{ message }">
              <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                {{ message }}
              </div>
            </ErrorMessage>
            <button type="submit" class="btn flex justify-center mt-10" value="modifier">
              <span>Modifier</span>
            </button>
          </VeeForm>
      </div>
  </Dialog>
</template>
